<div class="card">
  <div class="section-1">
    <div class="question-1-title">
      {{ question()?.title }}
    </div>
    <div style="text-align: center">
      <mat-radio-group (change)="valueSelected($event)" aria-label="Select an option">
        <mat-radio-button value="no"></mat-radio-button>
        <mat-radio-button value="unsure"></mat-radio-button>
        <mat-radio-button value="yes"></mat-radio-button>
      </mat-radio-group>
      <div style="display: block; margin: 0 auto; width: 299px">
        <div class="label-section">
          <div class="radio-label">
            <h3>No</h3>
          </div>
          <div class="radio-label">
            <h3>Unsure</h3>
          </div>
          <div class="radio-label" style="padding-right: 5px">
            <h3>Yes</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
